module.exports = __webpack_public_path__ + "static/img/cpzx_tu12.faec7fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spzx_xqy/cpzx_tu12.png
// module id = nr6b
// module chunks = 1